import { render, staticRenderFns } from "./UserFeedbackPieChart.vue?vue&type=template&id=4b7a7afe&"
import script from "./UserFeedbackPieChart.vue?vue&type=script&lang=js&"
export * from "./UserFeedbackPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports